import { render } from "./CustomRadioField.vue?vue&type=template&id=166ff95c&scoped=true"
import script from "./CustomRadioField.vue?vue&type=script&lang=js"
export * from "./CustomRadioField.vue?vue&type=script&lang=js"

import "./CustomRadioField.vue?vue&type=style&index=0&id=166ff95c&lang=stylus&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-166ff95c"]])

export default __exports__